import { useSearchParams } from "react-router";
const queryParamName = "bundleId";
export function useBundleIdFormQueryString() {
  const [searchParams] = useSearchParams();

  const bundleId = searchParams.get(queryParamName);

  return {
    bundleId: bundleId ?? undefined,
  };
}
